<div class="flash-message_container" [@visibilityState]="visibilityState">
    <div class="flash-message_text" ngClass="{{sizeClass}}">
        {{flashMessageItem.message | l10n:flashMessageItem.messageArguments}}
    </div>
</div>
